import home from './home'
import board from './board'
import attendance from './attendance'
import mypage from './mypage'
import webpart from './webpart'
import ywkboard from './ywkboard'


export default{
    home,
    board,
    attendance,
    mypage,
    webpart,
    ywkboard
}